<template>
  <p class="mt120 center">Page not found</p>
</template>

<script>
export default {
    name:"view404"
}
</script>

<style>

</style>